export default __webpack_public_path__ + "static/media/maxine_detail13.12229f32.jpg";